import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IAddLocatiePayload, IEditLocatiePayload } from './locatii.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LocatiiService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;
    //Getters
    private listLocatiiUrl =
        this.basePath +
        environment.interop.deps.nomenclatoare.locatii.list;
    private listDTLocatiiUrl =
        this.basePath +
        environment.interop.deps.nomenclatoare.locatii.listDT;

    //Update
    private storeLocatiiURL =
        this.basePath +
        environment.interop.deps.nomenclatoare.locatii.store;
    private putLocatiiURL =
        this.basePath +
        environment.interop.deps.nomenclatoare.locatii.update;

    //Delete
    private deleteLocatiiURL =
        this.basePath +
        environment.interop.deps.nomenclatoare.locatii.delete;

    constructor(private http: HttpClient) { }

    listLocatii() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.listLocatiiUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_locatie,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get locatii:', error);
                    return throwError(error);
                })
            );
    }

    listDTLocatii() {
        return this.http.post(this.listDTLocatiiUrl, this.httpOptions);
    }

    addLocatii(locatii: IAddLocatiePayload) {
        return this.http.post(this.storeLocatiiURL, locatii, this.httpOptions);
    }

    updateLocatii(locatii: IEditLocatiePayload) {
        return this.http.put(this.putLocatiiURL, locatii, this.httpOptions);
    }

    deleteLocatii(locatiiId: number) {
        return this.http.delete(this.deleteLocatiiURL + locatiiId);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
